import { useElapsedTime } from "@circle-react/hooks/useElapsedTime";
import { Toolbar } from "../../Toolbar";

interface ElapsedTimeIndicatorProps {
  liveAt: string;
}

export const ElapsedTimeIndicator = ({ liveAt }: ElapsedTimeIndicatorProps) => {
  const elapsedTime = useElapsedTime(liveAt);
  return <Toolbar.Indicator label={elapsedTime} hideBackground disabled />;
};
